import axios from "axios";

class QuizShowAdminRepository {
  createGame(params = {}, callback) {
    axios.post("/v1/api/quizshow-admin/games", params)
      .then((res) => {
        if (res.status === 200)
          callback && callback(res.data);
      });
  }

  updateGame(params = {}, callback) {
    axios.put(`/v1/api/quizshow-admin/games/${params.id}`, params)
      .then((res) => {
        if (res.status === 200)
          callback && callback(res.data);
      });
  }

  searchGame(params = {}, callback) {
    axios.get(`/v1/api/quizshow-admin/games`)
      .then((res) => {
        if (res.status === 200)
          callback && callback(res.data);
      });
  }

  findGame(params, callback) {
    axios.get(`/v1/api/quizshow-admin/games/${params.id}`)
      .then((res) => {
        if (res.status === 200)
          callback && callback(res.data);
      });
  }

  deleteGame(params, callback) {
    axios.delete(`/v1/api/quizshow-admin/games/${params.id}`)
      .then((res) => {
        if (res.status === 200)
          callback && callback(res.data);
      });
  }

  joinGame(params, callback) {
    axios.put(`/v1/api/quizshow-admin/games/${params.id}:join`)
      .then((res) => {
        if (res.status === 200)
          callback && callback(res.data);
      });
  }

  activateGame(params = {}, callback) {
    axios.put(`/v1/api/quizshow-admin/games/${params.id}:activate`)
      .then((res) => {
        if (res.status === 200)
          callback && callback(res.data);
      });
  }

  deactivateGame(params = {}, callback) {
    axios.put(`/v1/api/quizshow-admin/games/${params.id}:deactivate`)
      .then((res) => {
        if (res.status === 200)
          callback && callback(res.data);
      });
  }

  findGameUser(params = {}, callback) {
    axios.get(`/v1/api/quizshow-admin/games/${params.id}/users`)
      .then((res) => {
        if (res.status === 200)
          callback && callback(res.data);
      });
  }

  leaveGameUser(params = {}, callback) {
    axios.put(`/v1/api/quizshow-admin/games/${params.id}/users/${params.userId}:leave`)
      .then((res) => {
        if (res.status === 200)
          callback && callback(res.data);
      });
  }

  reportGame(params, callback) {
    axios.get(`/v1/api/quizshow-admin/games/${params.id}/report`)
      .then((res) => {
        if (res.status === 200)
          callback && callback(res.data);
      });
  }

  //

  findMe(params = {}, callback) {
    axios.get(`/v1/api/quizshow-admin/me`)
      .then((res) => {
        if (res.status === 200)
          callback && callback(res.data);
      });
  }

  //

  createQuiz(params, callback) {
    axios.post(`/v1/api/quizshow-admin/quizzes`, params)
      .then((res) => {
        if (res.status === 200)
          callback && callback(res.data);
      });
  }

  searchQuiz(params, callback) {
    axios.get(`/v1/api/quizshow-admin/quizzes`, { params })
      .then((res) => {
        if (res.status === 200)
          callback && callback(res.data);
      });
  }

  findQuiz(params, callback) {
    axios.get(`/v1/api/quizshow-admin/quizzes/${params.id}`)
      .then((res) => {
        if (res.status === 200)
          callback && callback(res.data);
      });
  }

  updateQuiz(params, callback) {
    axios.put(`/v1/api/quizshow-admin/quizzes/${params.id}`, params)
      .then((res) => {
        if (res.status === 200)
          callback && callback(res.data);
      });
  }

  deleteQuiz(params, callback) {
    axios.delete(`/v1/api/quizshow-admin/quizzes/${params.id}`)
      .then((res) => {
        if (res.status === 200)
          callback && callback(res.data);
      });
  }

  startQuizExam(params, callback) {
    axios.put(`/v1/api/quizshow-admin/quizzes/${params.id}:start`)
      .then((res) => {
        if (res.status === 200)
          callback && callback(res.data);
      });
  }

  endQuizExam(params, callback) {
    axios.put(`/v1/api/quizshow-admin/quizzes/${params.id}:end`)
      .then((res) => {
        if (res.status === 200)
          callback && callback(res.data);
      });
  }

  reportQuiz(params = {}, callback) {
    axios.get(`/v1/api/quizshow-admin/quizzes/${params.id}/report`)
      .then((res) => {
        if (res.status === 200)
          callback && callback(res.data);
      });
  }

}

export { QuizShowAdminRepository };
